import ApiError from '@waiterio/api-client/ApiError'

export default function failure (response) {

	throw new ApiError(response)

}
